import script from "./Gender.vue?vue&type=script&setup=true&lang=js"
export * from "./Gender.vue?vue&type=script&setup=true&lang=js"

import "./Gender.vue?vue&type=style&index=0&id=7ed22f92&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed22f92"]])

export default __exports__